// 화면 17 (Leading Sector Timeline) REST 어댑터.
// 권위: docs/ARCH_DASHBOARD.md v1.10 §6.2 — `/api/v1/sectors/history` + `/sectors/history/divergence`.
//
// 백엔드 응답은 ApiResponse.ok(data, meta) — client.ts interceptor 가 data 만 추출 (meta 손실).
// `/sectors/history` 의 data 는 List<SectorHistoryRow> 자체.

import { apiGet } from './client';
import type {
  DivergencePanelResponse,
  SectorHistoryMode,
  SectorHistoryResponse,
} from '../pages/LeadingSectors/leadingSectors.types';

interface HistoryParams {
  from: string;
  to: string;
  mode: SectorHistoryMode;
  includeSparkline?: boolean;
  sector?: string;
}

function buildHistoryParams(p: HistoryParams): URLSearchParams {
  const qs = new URLSearchParams();
  qs.set('from', p.from);
  qs.set('to', p.to);
  qs.set('mode', p.mode);
  if (p.includeSparkline) qs.set('include_sparkline', 'true');
  if (p.sector && p.sector.trim()) qs.set('sector', p.sector.trim());
  return qs;
}

export async function getLeadingSectorHistory(
  params: HistoryParams
): Promise<SectorHistoryResponse> {
  const qs = buildHistoryParams(params).toString();
  return apiGet<SectorHistoryResponse>(`/api/v1/sectors/history?${qs}`);
}

export async function getLeadingSectorDivergence(
  date: string
): Promise<DivergencePanelResponse> {
  const qs = new URLSearchParams({ date }).toString();
  return apiGet<DivergencePanelResponse>(`/api/v1/sectors/history/divergence?${qs}`);
}
